<div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
  <div class="widget" id="doctor-filter"  fxFlex.gt-sm="100">
    <mat-form-field>
      <mat-label>Derivar todas las tareas al medico: </mat-label>
      <mat-select class="full-width-multi-select width-378" [formControl]="FormElement">
        <mat-option *ngFor="let doctor of DoctorList$" [value]="doctor.value">{{doctor.viewValue}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>